import React from "react";
import {
  Box,
  Breadcrumbs,
  Button,
  IconButton,
  Link,
  Typography,
  Paper,
  Tooltip,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import RefreshIcon from "@mui/icons-material/Refresh";
import CreateNewFolderIcon from "@mui/icons-material/CreateNewFolder";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

const Toolbar = ({
  currentPath,
  setCurrentPath,
  onUpload,
  onRefresh,
  onCreateFolder,
}) => {
  const primaryButtonSx = {
    backgroundColor: "#2f63ad",
    color: "white",
    fontWeight: 700,
    borderRadius: "10px",
    textTransform: "none",
    px: 2.25,
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#1f4f94",
      boxShadow: "none",
    },
  };

  const iconButtonSx = {
    borderRadius: "10px",
    border: "1px solid rgba(47,99,173,0.12)",
    backgroundColor: "rgba(47,99,173,0.03)",
    color: "#2f63ad",
    "&:hover": {
      backgroundColor: "rgba(47,99,173,0.08)",
    },
  };

  const pathParts = currentPath.split("/");

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        borderRadius: "16px",
        border: "1px solid rgba(47,99,173,0.08)",
        boxShadow: "0 8px 24px rgba(0,0,0,0.06)",
        backgroundColor: "rgba(255,255,255,0.96)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: { xs: "flex-start", md: "center" },
          flexDirection: { xs: "column", md: "row" },
          gap: 2,
        }}
      >
        <Box sx={{ minWidth: 0, width: "100%" }}>
          <Typography
            variant="body2"
            sx={{
              color: "#6b778c",
              fontWeight: 600,
              mb: 0.75,
            }}
          >
            Current Location
          </Typography>

          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            sx={{
              flexWrap: "wrap",
              "& .MuiBreadcrumbs-ol": {
                flexWrap: "wrap",
              },
            }}
          >
            {pathParts.map((part, i) => {
              const path = pathParts.slice(0, i + 1).join("/");
              const isLast = i === pathParts.length - 1;

              return isLast ? (
                <Typography
                  key={i}
                  sx={{
                    color: "#223142",
                    fontWeight: 700,
                    wordBreak: "break-word",
                  }}
                >
                  {part}
                </Typography>
              ) : (
                <Link
                  key={i}
                  component="button"
                  type="button"
                  underline="hover"
                  onClick={() => setCurrentPath(path)}
                  sx={{
                    cursor: "pointer",
                    color: "#2f63ad",
                    fontWeight: 600,
                    textAlign: "left",
                  }}
                >
                  {part}
                </Link>
              );
            })}
          </Breadcrumbs>
        </Box>

        <Box
          sx={{
            display: "flex",
            gap: 1.25,
            flexWrap: "wrap",
            alignItems: "center",
            width: { xs: "100%", md: "auto" },
          }}
        >
          <input type="file" hidden id="upload" onChange={onUpload} />

          <label htmlFor="upload">
            <Button
              variant="contained"
              startIcon={<CloudUploadIcon />}
              component="span"
              sx={primaryButtonSx}
            >
              Upload
            </Button>
          </label>

          <Tooltip title="Refresh">
            <IconButton onClick={onRefresh} sx={iconButtonSx}>
              <RefreshIcon />
            </IconButton>
          </Tooltip>

          <Tooltip title="Create Folder">
            <IconButton onClick={onCreateFolder} sx={iconButtonSx}>
              <CreateNewFolderIcon />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>
    </Paper>
  );
};

export default Toolbar;